import { render, staticRenderFns } from "./Scoolfolio.vue?vue&type=template&id=7c2a98a6&scoped=true"
import script from "@/views/Users/Student/Scoolfolio.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Scoolfolio.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/scoolfolio.scss?vue&type=style&index=0&id=7c2a98a6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2a98a6",
  null
  
)

export default component.exports